import companyLogo from 'assets/funnel/powerserv_logo_2.png';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import heroImg from 'assets/funnel/labor_927_1.jpg';
import infoHeroImg from 'assets/funnel/labor_927_2.jpg';
import jobDetailsImg from 'assets/funnel/labor_927_3.jpg';
import groupImg from 'assets/funnel/labor_927_4.jpg';

const labor_927 = {
  documentTitle: "Labormitarbeiter (m/w/d) Pharma – Produktanalytiker:in in der Qualitätskontrolle | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Vollzeit · €3.463 / Monat · Wien",
    heroTitle: "Labormitarbeiter (m/w/d) · Pharma Qualitätskontrolle",
    heroSubtitle: "Qualitätskontrolle mit HPLC/UPLC-Analytik bei einem weltweit tätigen Pharmaunternehmen in 1210 Wien.",
    facts: [
      { icon: 'bi-cash-stack',   title: '€ 3.463,06 / Monat',     subtitle: 'Brutto-Mindestlohn + Überzahlung möglich' },
      { icon: 'bi-geo-alt-fill', title: '1210 Wien',              subtitle: 'öffentlich erreichbar' },
      { icon: 'bi-clock',        title: '38 Wochenstunden',       subtitle: 'Vollzeit' },
      { icon: 'bi-globe',        title: 'Weltweit tätiger Konzern', subtitle: 'Langfristige Perspektive' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: " €3.463 / Monat · Vollzeit · Pharma & Qualitätskontrolle",
    heroTitleLines: ["Produktanalytiker:in", "(m/w/d)"],
    facts: [
      { value: "€ 3.463", label: "Brutto-Mindestlohn + Überzahlung möglich" },
      { value: "Vollzeit", label: "1210 Wien" },
    ],
    moechtestDuItems: [
      { icon: 'bi-capsule',        text: 'Produkt-Analytik fester Arzneiformen mit Schwerpunkt HPLC/UPLC und GC eigenverantwortlich durchführen und fachlich anleiten?' },
      { icon: 'bi-search',         text: 'Root Cause Analysen im Abweichungsmanagement durchführen und Analysenmethoden sowie Laborgeräte optimieren?' },
      { icon: 'bi-graph-up-arrow', text: 'bei einem weltweit tätigen Pharmakonzern langfristig Verantwortung übernehmen und Qualitätssicherungssysteme weiterentwickeln?' },
    ],
    benefits: [
      { icon: 'bi-globe',        title: 'Weltweit tätiger Konzern',       desc: 'Die Chance, für einen weltweit tätigen Konzern zu arbeiten.' },
      { icon: 'bi-shield-check', title: 'Vollzeitbeschäftigung',          desc: 'Vollzeitbeschäftigung mit 38 Wochenstunden.' },
      { icon: 'bi-signpost-2',   title: 'Gute Erreichbarkeit',            desc: 'Standort öffentlich erreichbar.' },
      { icon: 'bi-book',         title: 'Abwechslungsreiches Aufgabengebiet', desc: 'Ein abwechslungsreiches, spannendes Betätigungsfeld.' },
      { icon: 'bi-award',        title: 'Renommierter Arbeitgeber',       desc: 'Traditionelles, angesehenes Unternehmen mit langfristigen Perspektiven.' },
    ],
    aufgabenTitle: "Analytik mit Verantwortung.",
    tasks: [
      'Durchführung und fachliche Anleitung von Produkt-Analytik fester Arzneiformen mit Schwerpunkt HPLC/UPLC und GC',
      'Durchführung von und fachliche Unterstützung bei Methodenvalidierungen',
      'Eigenständige Root Cause Analysen im Rahmen von Abweichungsmanagement und Optimierungsprojekten',
      'Fachliche Unterstützung und Trouble Shooting bei Analysenmethoden und Laborgeräten',
      'Mitwirkung bei Audits, Inspektionen und Gemba Walks (GMP und Safety)',
      'Einschulung neuer Mitarbeiter:innen und abteilungsübergreifende Zusammenarbeit bei Planungstätigkeiten',
    ],
    requirements: [
      'Abgeschlossene chemisch-technische oder naturwissenschaftliche Ausbildung (z. B. Lehre, HTL oder Studium in Chemie, Pharmazie, Lebensmittel- und Biotechnologie)',
      'Vorerfahrung mit HPLC/UPLC-Analytik unbedingt erforderlich',
      'Erfahrung in der pharmazeutischen Industrie sowie GMP-Kenntnisse',
      'Sicherer Umgang mit MS Office-Software',
      'Selbständige, genaue und lösungsorientierte Arbeitsweise',
      'Ausgezeichnete Deutsch- und sehr gute Englischkenntnisse in Wort und Schrift',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Pharma &", "Qualitätskontrolle"],
    noteText: "Präzise, eigenverantwortliche Persönlichkeit mit Laborerfahrung? Dann bewirb dich jetzt – wir freuen uns auf dich.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default labor_927;
